import React, { useState } from "react";
import disclosures from "../../data/importantDisclosures.json";
import "./RequiredDisclosures.css";

const RequiredDisclosures = ({ onContinue, onBack, onSaveLater, loading }) => {
  const [acknowledged, setAcknowledged] = useState(false);

  return (
    <article className="cc-required-disclosures">
      <h1 className="cc-course-title">{disclosures.title}</h1>
      <p className="cc-course-meta">Class 2 of 14 - Pre-Filing Credit Counseling</p>
      <div className="cc-required-disclosures__copy">
        {disclosures.blocks.map((block, index) => {
          if (block.type === "heading") return <h2 key={index}>{block.text}</h2>;
          if (block.type === "list") return <ul key={index}>{block.items.map((item) => <li key={item}>{item}</li>)}</ul>;
          return <p key={index}>{block.text}</p>;
        })}
      </div>
      <label className={`cc-required-disclosures__acknowledgment${acknowledged ? " is-checked" : ""}`}>
        <input type="checkbox" checked={acknowledged} disabled={loading} onChange={(event) => setAcknowledged(event.target.checked)} />
        <span>{disclosures.acknowledgment}</span>
      </label>
      <div className="footer-form-btn d-flex flex-wrap mt-4">
        <button type="button" className="btn_brnd cc-action-back" onClick={onBack} disabled={loading}>Go Back</button>
        <button type="button" className="btn_brnd cc-action-save-later" onClick={onSaveLater} disabled={loading}>Save and Return Later</button>
        <button type="button" className="btn_brnd btn-next" disabled={!acknowledged || loading} onClick={() => { if (acknowledged && !loading) onContinue(); }}>Save and Continue</button>
      </div>
    </article>
  );
};

export default RequiredDisclosures;
